import { MemoryCache } from './memoryCache';
import { kebabCase } from './utils';
export class ReaderList extends MemoryCache {
    constructor(path) {
        super();
        this.path = path;
        this.getList = () => this.wrapPromise(path, this.fetch.bind(this));
    }
    async fetch() {
        try {
            const res = await window.fetch(this.path);
            if (!res.ok) {
                return null;
            }
            const text = await res.text();
            const list = JSON.parse(text);
            return this.mapImagesToSources(list);
        }
        catch (error) {
            console.log(error); // eslint-disable-line
            throw error;
        }
    }
    useGoogleFavicon(url) {
        return `https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${url}&size=32`;
    }
    mapImagesToSources(list) {
        return list.map((category) => {
            var _a;
            if (!((_a = category.sources) === null || _a === void 0 ? void 0 : _a.length)) {
                return category;
            }
            return Object.assign(Object.assign({}, category), { sources: category.sources.map((source) => {
                    return Object.assign(Object.assign({}, source), { id: source.id || kebabCase(source.name), image: source.image || this.useGoogleFavicon(source.url) });
                }) });
        });
    }
}
